import { CountryList } from '../components/AttestationSection/AttestationSection.content';
import { SelectableOptionItem } from '@betty/navigation';

export const getPhoneCodeSelectableOptions = (): SelectableOptionItem[] => {
  return CountryList.map((country) => ({
    image: {
      source: `https://flagcdn.com/w20/${country.code.toLowerCase()}.png`,
    },
    text: `+${country.phone} ${country.label}`,
  }));
};
